export const appConfig = {
    logoUrl: 'assets/img/airline/demo-airline.png'
}